import * as React from "react";

const Contacts = () => (
    <div />
);

export default Contacts;
